export const PaletaColor = {
    COLOR_BACKGROUND_VERDER_AGUA: '#48c590',
    COLOR_BACKGROUND_BLANCO: "#ffffff",
    COLOR_BACKGROUND_VERDE_CLARO: "#e2f7ed",
    COLOR_BACKGROUND_AZUL_CLARO: "#4962c7",
    COLOR_BACKGROUND_GRIS: "#777777",
    COLOR_BACKGROUND_GRIS_CLARO: "#e7e7e7",
    COLOR_AMARILLO: "#efce22",
    HEADER_COLOR: "#000000",
    NEGRO: '#2b2a29',
    ROJO: '#dd4b39',
    AZUL_OSCURO: '#114469',
    BLANCO: '#ffffff',
    VERDE: '#00a65a'
};

export const FontSizeText = {
    H1: 24,
    H2: 20,
    H3: 18,
    H4: 16,
    H5: 14,
    H6: 12,
    H7: 10,
    H8: 8,
    H9: 6,
};

//padding
export const Padding = {
    P1: 5,
    P2: 10,
    P3: 15,
    P4: 20,
    P5: 25,
    P6: 30,
    P7: 35,
    P8: 40,
    P9: 45,
    P10: 50,
};